export default __webpack_public_path__ + "static/ecl-e6f7a2fd6969d3b17428b9dec9a3f746.png";